/* eslint-disable react/forbid-foreign-prop-types */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SelectSlide from '../../../../SelectSlide/SelectSlide';
import * as Styled from './OverlayHeader.styled';
/**
 * A modal is a controlled component which renders its children outside (and on top of)
 * the normal flow and blocks interaction with the rest of the page.
 * Modals are purposefully interruptive, so they should be used sparingly.
 *
 * Note: Modals come with `24px` of base padding around their content.
 */
var OverlayHeader = function (props) {
    var title = props.title, size = props.size, titleIcon = props.titleIcon, rightIcon = props.rightIcon, leftIcon = props.leftIcon, withCollapse = props.withCollapse, withDivider = props.withDivider, slides = props.slides, selectedSlide = props.selectedSlide, onSelectSlide = props.onSelectSlide, variant = props.variant, _a = props.alignment, alignment = _a === void 0 ? 'center' : _a;
    var titleRender = typeof title === 'string' ? (React.createElement(Styled.Title, { variant: variant }, title)) : (title);
    return (React.createElement(Styled.DialogHeader, { withCollapse: withCollapse, hasSlides: !!slides && slides.length > 1 },
        React.createElement(Styled.DialogHeaderUpper, null,
            React.createElement(Styled.FixedComponent, { side: "left" }, leftIcon),
            title && (React.createElement(Styled.TitleWrapper, { variant: variant, alignment: alignment },
                titleRender,
                titleIcon && (titleIcon))),
            React.createElement(Styled.FixedComponent, { side: "right" }, rightIcon)),
        React.createElement(Styled.DialogHeaderLower, { size: size, hasSlides: !!slides && slides.length > 1, withDivider: withDivider }, slides && slides.length > 1 && React.createElement(SelectSlide, { name: "modal_slideoptions", onChange: onSelectSlide, selectedOption: String(selectedSlide) }, slides.map(function (tagProps, index) { return (React.createElement(SelectSlide.Option, __assign({}, tagProps, { key: index, value: index.toString() }))); })))));
};
export default OverlayHeader;
